module.exports = __webpack_public_path__ + "static/media/MHRP25N0005.06f0a10b.svg";